export default __webpack_public_path__ + "static/media/TVS KING GS+ FULL_4.980f66ea.webp";